module.exports = __webpack_public_path__ + "img/cukn.95550287.jpg";